import { useState } from "react";
import { Share2, Copy, Download, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { API } from "../lib/api";

/**
 * Premium share popover. `kind` + `id` build the authoritative card/share URLs.
 * card: GET {API}/cards/{path}.png   share: {API}/share/{path}
 */
export function ShareButton({ kind, id, label = "Share", testid }) {
  const [copied, setCopied] = useState(false);
  const paths = {
    match: `match/${id}`, player: `player/${id}`, champion: `champion/${id}`,
    nation: `nation/${id}`, table: `table/${id}`,
  };
  const path = paths[kind];
  const cardUrl = `${API}/cards/${path}.png`;
  const shareUrl = `${API}/share/${kind}/${id}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      window.prompt("Copy this share link:", shareUrl);
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={testid || `share-${kind}-btn`}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-[#0f0f0f] border border-[#2b2512] text-slate-200 text-sm font-medium hover:border-[#E5B842]/50 hover:text-[#E5B842]"
          style={{ transition: "border-color 0.15s ease, color 0.15s ease" }}>
          <Share2 className="w-4 h-4" /> {label}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-[#070707] border-[#2b2512] p-3" data-testid="share-popover">
        <div className="rounded-lg overflow-hidden border border-[#2b2512] bg-[#000000] mb-3">
          <img src={cardUrl} alt="Share card preview" data-testid="share-card-preview"
            className="w-full block" loading="lazy" />
        </div>
        <div className="flex gap-2">
          <button onClick={copy} data-testid="share-copy-link"
            className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-[#E5B842] text-[#000000] text-sm font-bold hover:brightness-110"
            style={{ transition: "filter 0.15s ease" }}>
            {copied ? <><Check className="w-4 h-4" /> Copied</> : <><Copy className="w-4 h-4" /> Copy link</>}
          </button>
          <a href={cardUrl} download={`wsbf-${kind}-${id}.png`} data-testid="share-download-png"
            className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-[#161616] border border-[#2b2512] text-slate-200 text-sm font-medium hover:border-[#E5B842]/50"
            style={{ transition: "border-color 0.15s ease" }}>
            <Download className="w-4 h-4" /> PNG
          </a>
        </div>
      </PopoverContent>
    </Popover>
  );
}
